import { NgModule } from '@angular/core';
import { Apollo } from 'apollo-angular';

@NgModule({
    imports: [],
    declarations: [],
    exports: [],
    providers: [Apollo],
})
export class EncounterGraphQLModule {}
